import React, { useState } from "react";
import Radio from "antd/lib/radio";
import Form from "antd/lib/form";
import moment from "moment";
import { AppDatePicker } from "components/inputs";
import { SurveyNumberInput } from "pages/symptoms/surveyForms/surveyNumberInput";
import { disableFutureDate } from "helpers/utils";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface HeartRateSectionProps {
  readonly currentPage: number;
}

export const HeartRateSection: React.FC<HeartRateSectionProps> = ({
  currentPage
}) => {
  const [heartRate, setHeartRate] = useState(
    localStorage.getItem(`reportHeartRate`) || ""
  );

  const checkHeartRate = (_: any, value: number) => {
    if (value) {
      if (value <= 150 && value >= 40) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(
          "Reading appears out of range. Please recheck and, if confirmed, call your doctor or go to ER immediately, especially if you have any symptoms."
        )
      );
    }
    return Promise.reject(new Error("This field is required"));
  };

  return (
    <>
      {currentPage === 6 && (
        <SurveyQuestionCard
          sectionTag="Heart Rate"
          title="Do you want to report your heart rate?"
          required
        >
          <div
            style={{
              color: "#4a5568",
              marginBottom: "14px",
              fontSize: "14px",
              lineHeight: "1.5"
            }}
          >
            PLEASE CALL YOUR DOCTOR OR CALL 911 AND GO TO NEAREST ER FOR ANY
            SERIOUS CHANGE IN YOUR VITAL SIGNS OUTSIDE YOUR USUAL RECOMMENDED
            RANGE, OR IF YOU HAVE ANY ASSOCIATED SYMPTOMS.
          </div>
          <FormItemStyle
            name="Report your heart rate"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("reportYourHeartRate")}
              onChange={e =>
                localStorage.setItem("reportYourHeartRate", e.target.value)
              }
            >
              <AnswerList>
                <AnswerOption value="Yes">Yes</AnswerOption>
                <AnswerOption value="No">No</AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 7 && (
        <SurveyQuestionCard
          sectionTag="Heart Rate"
          title="When did you take your heart rate?"
          required
        >
          <FormItemStyle
            name="When did you take your heart rate"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("whenWasHeartRateTaken")}
              onChange={e =>
                localStorage.setItem("whenWasHeartRateTaken", e.target.value)
              }
            >
              <AnswerList>
                <AnswerOption value="Taken today">Taken today</AnswerOption>
                <AnswerOption value="Taken before today">
                  Taken before today
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 8 && (
        <SurveyQuestionCard
          sectionTag="Heart Rate"
          title="When was your heart rate taken?"
          required
        >
          <FormItemStyle
            name="When was your heart rate taken(Date)"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <AppDatePicker
              label="Heart Rate Taken on"
              value={moment(localStorage.getItem("dateYourHeartRateWasTaken"))}
              onChange={e => {
                if (e) {
                  const selectedDate = moment(e).toISOString();
                  localStorage.setItem(
                    "dateYourHeartRateWasTaken",
                    selectedDate
                  );
                }
              }}
              style={{ width: "250px" }}
              disabledDate={disableFutureDate}
            />
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 9 && (
        <SurveyQuestionCard
          sectionTag="Heart Rate"
          title="Report heart rate"
          required
        >
          <FormItemStyle
            name={`Report heart rate`}
            label=""
            rules={[
              {
                required: true,
                validator: checkHeartRate,
                validateTrigger: "submit"
              }
            ]}
            initialValue={""}
          >
            <SurveyNumberInput
              value={heartRate}
              placeholder="Your Answer"
              decimalLimit={0}
              onChange={e => {
                setHeartRate(e as string);
                localStorage.setItem(`reportHeartRate`, e as string);
              }}
              min={0}
              style={{ width: "160px" }}
            />
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
